<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <div style="border-bottom:1px solid #e4e7ed;padding-bottom:10px">
          区域报警
        </div>
        <div class="common-alarm-div">
          <el-form
            :model="dataInfo"
            ref="form"
            :rules="dataInfoRules"
            label-width="80px"
          >
            <table class="alarm-table">
              <colgroup>
                <col style="width: 7%" />
                <col style="width: 30%" />
                <col style="width: 63%" />
              </colgroup>

              <tr>
                <td>
                  <p>是否启用</p>
                </td>
                <td>
                  <el-form-item prop="isApply">
                    <el-radio-group
                      v-model="dataInfo.alarmCommonAlarmSet.isApply"
                    >
                      <el-radio :label="radioLabel1">是</el-radio>
                      <el-radio :label="radioLabel0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
                <td>
                  <p>设置启用为“否”，该项报警设置暂时无效，直到重新启用。</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>选择区域</p>
                </td>
                <td>
                  <el-form-item prop="areaIdList" v-if="alarmSetId == 0">
                    <e6Select
                      :dataList="areaOptions"
                      :filterable="true"
                      slotTemplate="tree"
                      :issingleleaf="true"
                      multiple
                      ref="ae6select"
                      :placeholder="'请选择区域'"
                      v-model="dataInfo.areaIdList"
                    >
                    </e6Select>
                  </el-form-item>
                  <el-form-item v-if="alarmSetId !== 0">
                    <el-input
                      v-model="dataInfo.areaName"
                      size="small"
                      class="alarm-form-input"
                      :disabled="true"
                    />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <p>进区域报警</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group v-model="dataInfo.isInArea">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <p style="padding:0px 0px 0px 82px;margin:0px">
                    自定义通知内容
                  </p>
                  <el-form-item>
                    <el-input
                      v-model="dataInfo.inAreaMessage"
                      :disabled="dataInfo.isInArea == 1 ? false : true"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>
                </td>
                <td>
                  <p>
                    车辆进入区域时产生进区域报警
                    <br />自定义内容格式如下：<br />
                    左侧输入的自定义通知内容(最长50个字符)+时间：{xxx}车牌号：{xxx}
                    <br />
                    例如：<br />
                    您好：由A发往B的货物已出发。时间：08-31
                    14:34车牌号：陕AZ1656
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>出区域报警</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group
                      v-model="dataInfo.isOutArea"
                      :disabled="disabledByApply"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <p style="padding:0px 0px 0px 82px;margin:0px">
                    自定义通知内容
                  </p>
                  <el-form-item>
                    <el-input
                      v-model="dataInfo.outAreaMessage"
                      :disabled="dataInfo.isOutArea == 1 ? false : true"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>
                </td>
                <td>
                  <p>
                    车辆离开区域时产生出区域报警<br />
                    自定义内容格式如下：<br />
                    左侧输入的自定义通知内容(最长50个字符)+时间：{xxx}车牌号：{xxx}<br />
                    例如：<br />
                    您好：由A发往B的货物已到达。时间：08-31
                    16:34车牌号：陕AZ1656。
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>适用范围</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group
                      v-model="dataInfo.alarmCommonAlarmSet.isOverAll"
                      :disabled="alarmSetId == 0 ? false : true"
                    >
                      <el-radio :label="1">全局设置</el-radio>
                      <el-radio :label="0">自定义车辆</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item v-if="alarmSetId == 0" prop="vehicleIdList">
                    <e6Select
                      v-show="dataInfo.alarmCommonAlarmSet.isOverAll == '0'"
                      :dataList="options"
                      :filterable="true"
                      slotTemplate="tree"
                      :issingleleaf="true"
                      multiple
                      ref="ve6select"
                      :placeholder="'请选择车辆'"
                      v-model="dataInfo.vehicleIdList"
                    >
                    </e6Select>
                  </el-form-item>
                  <el-form-item
                    v-if="
                      alarmSetId !== 0 &&
                        dataInfo.alarmCommonAlarmSet.isOverAll == 0
                    "
                  >
                    <el-input
                      v-model="dataInfo.vehicleNo"
                      size="small"
                      class="alarm-form-input"
                      :disabled="true"
                    />
                  </el-form-item>
                </td>
                <td>
                  <p>
                    对指定车辆自定义设置，选择的车辆按照所设置参数进行报警业务判断。<br />
                    若车辆某项报警进行了自定义设置，全局设置参数针对此车不起作用。
                  </p>
                </td>
              </tr>
              <!-- <tr>
                <td colspan="3">
                  <el-button type="text" @click="switchSetting">
                    <i
                      :class="[
                        advancedSettingShow
                          ? 'el-icon-arrow-up'
                          : 'el-icon-arrow-down'
                      ]"
                    ></i
                    >{{ switchSettingBtnText }}
                  </el-button>
                </td>
              </tr> -->
            </table>

            <!-- <table v-show="advancedSettingShow" class="alarm-table">
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 30%" />
                <col style="width: 55%" />
              </colgroup>
              <tr>
                <td>
                  <p>区域停车报警</p>
                </td>
                <td>
                  <el-radio-group v-model="dataInfo.inOrOutAreaStop">
                    <el-radio :label="1">区域内</el-radio>
                    <el-radio :label="0">区域外</el-radio>
                  </el-radio-group>
                  <el-form-item
                    v-if="dataInfo.inOrOutAreaStop == 1"
                    prop="inAreaStopTime"
                  >
                    <el-input
                      v-model="dataInfo.inAreaStopTime"
                      size="small"
                      class="alarm-form-input"
                    >
                      <template slot="prepend">停车时长</template>
                      <template slot="append">分钟</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-else prop="outAreaStopTime">
                    <el-input
                      v-model="dataInfo.outAreaStopTime"
                      size="small"
                      class="alarm-form-input"
                    >
                      <template slot="prepend">停车时长</template>
                      <template slot="append">分钟</template>
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <p>区域开门报警</p>
                </td>
                <td>
                  <el-radio-group v-model="dataInfo.inOrOutAreaOpenDoor">
                    <el-radio :label="1">区域内</el-radio>
                    <el-radio :label="0">区域外</el-radio>
                  </el-radio-group>
                  <el-form-item
                    v-if="dataInfo.inOrOutAreaStop == 1"
                    prop="inAreaOpenDoorTime"
                  >
                    <el-input
                      v-model="dataInfo.inAreaOpenDoorTime"
                      size="small"
                      class="alarm-form-input"
                      :disabled="disabledByApply || dataInfo.isStopAlarm == 0"
                    >
                      <template slot="prepend">开门时长</template>
                      <template slot="append">分钟</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-else prop="outAreaOpenDoorTime">
                    <el-input
                      v-model="dataInfo.outAreaOpenDoorTime"
                      size="small"
                      class="alarm-form-input"
                      :disabled="disabledByApply || dataInfo.isStopAlarm == 0"
                    >
                      <template slot="prepend">开门时长</template>
                      <template slot="append">分钟</template>
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <p>区域内超速报警</p>
                </td>
                <td>
                  <el-radio-group v-model="dataInfo.isInAreaOverSpeed">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>

                  <el-form-item prop="inAreaOverSpeed">
                    <el-input
                      v-model="dataInfo.inAreaOverSpeed"
                      size="small"
                      class="alarm-form-input"
                      :disabled="dataInfo.isInAreaOverSpeed == 0"
                    >
                      <template slot="prepend">超速值</template>
                      <template slot="append">km/h</template>
                    </el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td>
                  <p>区域预警</p>
                </td>
                <td>
                  <el-radio-group v-model="dataInfo.isAreaEarlyAlarm">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>

                  <el-form-item prop="areaEarlyDistance">
                    <el-input
                      v-model="dataInfo.areaEarlyDistance"
                      size="small"
                      class="alarm-form-input"
                      :disabled="dataInfo.isAreaEarlyAlarm == 0"
                    >
                      <template slot="prepend">预警距离</template>
                      <template slot="append">m</template>
                    </el-input>
                  </el-form-item>
                  <p style="padding:0px 0px 0px 82px;margin:0px">
                    自定义预警内容
                  </p>
                  <el-form-item>
                    <el-input
                      v-model="dataInfo.areaEarlyContent"
                      :disabled="dataInfo.isAreaEarlyAlarm == 1 ? false : true"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <p>平台显示</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group
                      v-model="dataInfo.alarmCommonAlarmSet.isPlateformShow"
                      :disabled="disabledByApply"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
                <td>
                  <p>
                    设置平台显示为“否”，报警处理及报警报表中记录报警信息，但是报警提示框与车辆定位监控不显示发生的报警信息。
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>警音提醒</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group
                      v-model="dataInfo.alarmCommonAlarmSet.isAlarmSound"
                      :disabled="disabledByApply"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
                <td>
                  <p>
                    设置警音提醒显示为“是”，当发生报警的时候，平台会有警音提醒。
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>通知终端</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group
                      v-model="dataInfo.alarmCommonAlarmSet.isTerminalShow"
                      :disabled="disabledByApply"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
                <td>
                  <p>
                    若设置邮件提醒，当发生报警时将报警信息通过邮件方式发送给联系人。若您开通了短信提醒，设置短信提醒，当发生报警时将报警信息通过手机短信发送给联系人。若设置了微信通知，并且联系人绑定了微信号，当发生报警时将报警信息通过服务号发送给联系人。现在就去设置。
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>闪拍</p>
                </td>
                <td>
                  <el-form-item>
                    <el-radio-group
                      v-model="dataInfo.alarmCommonAlarmSet.isPhoto"
                    >
                      <el-radio :label="0">关闭</el-radio>
                      <el-radio :label="1">开启-拍照</el-radio>
                      <el-radio :label="2">开启-10s短视频</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item v-show="isPhoto">
                    <span>选择通道&nbsp;&nbsp;</span>
                    <el-checkbox-group v-model="checkRouteList">
                      <el-checkbox label="1">1路</el-checkbox>
                      <el-checkbox label="2">2路</el-checkbox>
                      <el-checkbox label="3">3路</el-checkbox>
                      <el-checkbox label="4">4路</el-checkbox>
                      <el-checkbox label="5">5路</el-checkbox>
                      <el-checkbox label="6">6路</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item v-show="isVideo"
                    ><span>拍照次数&nbsp;&nbsp;</span>
                    <el-select
                      v-model="dataInfo.alarmCommonAlarmSet.photoNumber"
                      placeholder="拍照次数"
                    >
                      <el-option
                        v-for="item in photoNumList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-show="isVideo"
                    ><span>拍照间隔&nbsp;&nbsp;</span>
                    <el-select
                      v-model="dataInfo.alarmCommonAlarmSet.photoInterval"
                      placeholder="拍照间隔"
                    >
                      <el-option
                        v-for="item in photoTimeSpanList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>
                  <p>
                    若选择开启，发生报警时，可抓拍照片或录制10s短视频（需安装摄像头）。
                  </p>
                </td>
              </tr>
            </table> -->
          </el-form>
        </div>
        <div class="text-c mt30 common-alarm-btndiv">
          <el-button type="primary" @click="addData()" :loading="loadingState"
            >保存</el-button
          >
          <el-button @click="cancelSubmit()">取消</el-button>
        </div>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import e6Select from "e6select";

import resizeListener from "_private/mixins/resizeListener";
import { validatorIntNum } from "@/utils/validate.js";
import {
  FetchFindByPage,
  FetchSaveAreaAlarmSet,
  FetchFindAreaTree,
  FetchFindAreaAlarmById
} from "@/api/alarmSet/areaAlarmSet";
import { FetchVehicleTree } from "@/api/base/vehicle";
export default {
  mixins: [resizeListener],
  components: { e6Select },
  data: function() {
    let validatorVehicle = (rule, value, callback) => {
      let overAll = this.dataInfo.alarmCommonAlarmSet.isOverAll;
      let result = false;
      if (overAll) {
        if (value) {
          callback();
        } else {
          callback(new Error("请选择车辆！"));
        }
      } else {
        callback();
      }
    };
    return {
      isVideo: false,
      isPhoto: false,
      loadingState: false,
      pageTitle: "新增报警",
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "主页"
          }
        },
        {
          path: "/areaAlarmSetList",
          isRedirect: true,
          meta: {
            title: "区域报警设置列表"
          }
        }
      ],
      loadingState: false,
      options: [],
      /*   checkRouteList:[],*/
      areaOptions: [],
      advancedSettingShow: false,
      switchSettingBtnText: "打开高级设置",
      disabledByApply: false,
      dataInfo: {
        isStopAlarm: 1,
        isInArea: 0,
        areaIdList: [],
        areaName: "",
        inAreaMessage: "",
        isOutArea: 0,
        outAreaMessage: "",
        inOrOutAreaOpenDoor: 0,
        inOrOutAreaStop: 0,
        isInAreaOverSpeed: 0,
        isAreaEarlyAlarm: 0,
        areaEarlyContent: 0,
        alarmCommonAlarmSet: {
          isOverAll: 1,
          isApply: 1,
          isPlateformShow: 0,
          isAlarmSound: 0,
          isTerminalShow: 0,
          isPhoto: 0
        }
      },
      dataInfoRules: {
        areaEarlyDistance: [{ validator: validatorIntNum, trigger: ["blur"] }],
        inAreaOverSpeed: [{ validator: validatorIntNum, trigger: ["blur"] }],
        inAreaStopTime: [{ validator: validatorIntNum, trigger: ["blur"] }],
        outAreaStopTime: [{ validator: validatorIntNum, trigger: ["blur"] }],
        inAreaOpenDoorTime: [{ validator: validatorIntNum, trigger: ["blur"] }],
        outAreaOpenDoorTime: [
          { validator: validatorIntNum, trigger: ["blur"] }
        ],
        areaIdList: [
          { required: true, message: "请选择区域", trigger: ["change"] }
        ],
        vehicleIdList: [{ validator: validatorVehicle, trigger: ["change"] }]
      }
    };
  },
  computed: {
    radioLabel0() {
      return 0;
    },
    radioLabel1() {
      return 1;
    },
    radioLabel2() {
      return 2;
    },
    //是否新增
    isCreate() {
      return this.$route.query.isCreate ? this.$route.query.isCreate : false;
    },
    //编辑报警类型
    editType() {
      return this.$route.query.editType ? this.$route.query.editType : 0;
    },
    //报警ID
    alarmSetId() {
      return this.$route.query.alarmSetId ? this.$route.query.alarmSetId : 0;
    }
    /*photoRoute() {
                let ids = this.checkRouteList.map(item => {
                    return item;
                });
                return ids.length < 1 ? "" : ids.join(",");
            }*/
  },
  created() {
    if (this.editType != 0) {
      //编辑时设置当前显示tab页
      this.setActiveName();
      this.pageTitle = "编辑报警";
    }
    let breadcrumb = {
      path: "/areaAlarmSetEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
  },
  methods: {
    /* handleCheckedPhotoRouteChange(value) {
                dataInfo.alarmCommonAlarmSet.photoRoute
                this.checkRoute= this.checkRoute+value+',';
            },*/
    //根据ID获取设置信息
    FetchFindAreaAlarmById(data) {
      FetchFindAreaAlarmById(data)
        .then(response => {
          if (response.result) {
            this.dataInfo = response.result;
            /*  this.chagePhotShow(response.result.alarmCommonAlarmSet.isPhoto);*/
            /*  this.checkRouteList=[1,2,3];*/
            /*this.checkRouteList= response.result.alarmCommonAlarmSet.photoRoute.split(',');*/
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 取消
    cancelSubmit() {
      this.$router.push("/areaAlarmSetList");
    },
    //初始化车辆树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.options = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    initAreaTree() {
      FetchFindAreaTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.areaOptions = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 保存停车报警设置
     */
    addData() {
      if (this.alarmSetId == 0) {
        this.dataInfo.vehicleIdList = this.getVehicleIdListParam();
        this.dataInfo.areaIdList = this.getAreaIdListParam();
        if (this.dataInfo.areaIdList.length == 0) {
          this.$message({
            showClose: true,
            message: "请选择区域",
            type: "waring",
            duration: 2000
          });
          return;
        }
        if (
          this.dataInfo.vehicleIdList.length == 0 &&
          this.dataInfo.alarmCommonAlarmSet.isOverAll == 0
        ) {
          this.$message({
            showClose: true,
            message: "请选择车辆",
            type: "waring",
            duration: 2000
          });
          return;
        }
      } else {
        this.dataInfo.vehicleIdList = [];
        this.dataInfo.vehicleIdList.push(
          this.dataInfo.alarmCommonAlarmSet.vehicleId
        );
        this.dataInfo.areaIdList = [];
        this.dataInfo.areaIdList.push(this.dataInfo.areaID);
      }
      this.dataInfo.isInAreaOpenDoor =
        this.dataInfo.inOrOutAreaOpenDoor == 1 ? 1 : 0;
      this.dataInfo.isOutAreaOpenDoor =
        this.dataInfo.inOrOutAreaOpenDoor == 1 ? 0 : 1;
      //this.dataInfo.alarmCommonAlarmSet.photoRoute=this.photoRoute;
      //新增
      this.FetchSaveAreaAlarmSet(this.dataInfo);
    },
    //获取选中车辆id
    getVehicleIdListParam() {
      let selected = this.$refs.ve6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    //获取选中车辆id
    getAreaIdListParam() {
      let selected = this.$refs.ae6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    //新增
    FetchSaveAreaAlarmSet(data) {
      FetchSaveAreaAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增、修改完成时的回调函数
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push("/areaAlarmSetList");
          }
        }
      });
    },

    //切换是否显示高级设置
    switchSetting() {
      this.advancedSettingShow = !this.advancedSettingShow;
      if (this.advancedSettingShow) {
        this.switchSettingBtnText = "收起高级设置";
      } else {
        this.switchSettingBtnText = "打开高级设置";
      }
    }
    //是否拍照
    /* chagePhotShow(val){
                this.isPhoto=false;
                this.isVideo=false;
                 if(val==1){
                     this.isPhoto=true;
                 }
                 if(val==2){
                     this.isVideo=true;
                 }
            }*/
  },
  mounted() {
    //初始化车辆树
    this.initVehicleTree();
    this.initAreaTree();
    if (this.alarmSetId != 0) {
      //根据ID查询报警信息
      this.FetchFindAreaAlarmById({ alarmSetId: this.alarmSetId });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 20px 10px;
}

.content-section {
  overflow: auto;
}

.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}

.my-tree {
  width: 210px;
  line-height: 28px;
  margin-right: 10px;
}
.alarm-table {
  width: 100%;
}
.alarm-table tr {
  border-bottom: 1px gainsboro solid;
  min-height: 5px;
}
.alarm-table tr td {
  vertical-align: top;
  height: auto;
  padding-top: 5px;
  padding-bottom: 10px;
}
.alarm-table tr td p {
  margin-top: 13px;
}
.alarm-table tr td input {
}
// .common-alarm-div{
//     height: 600px;
//     overflow: auto;
// }
.alarm-form-input {
  width: 350px;
}
.common-alarm-btndiv {
  margin: 50px 0px;
  text-align: center;
}

/deep/ .e6-from--column-2 {
  .el-input {
    width: 240px;
  }
  .el-textarea__inner {
    width: 240px;
  }
}
</style>
